import type { Category } from '@/api/types'

export interface ChannelCategory {
  code: Category
  kor: string
  eng: string
  emoji: string
}

export const ChannelCategories = [
  { code: 'VLOG', kor: '브이로그', eng: '', emoji: '📹' },
  { code: 'PERSONAL', kor: '개인방송', eng: '', emoji: '🎤' },
  { code: 'FASHION', kor: '패션', eng: '', emoji: '👗' },
  { code: 'BEAUTY', kor: '뷰티', eng: '', emoji: '💄' },
  { code: 'GAMING', kor: '게임', eng: '', emoji: '🎮' },
  { code: 'HOBBY', kor: '취미', eng: '', emoji: '🎨' },
  { code: 'REVIEW', kor: '상품리뷰', eng: '', emoji: '🛍️' },
  { code: 'TECH', kor: '테크·과학', eng: '', emoji: '💻' },
  { code: 'KNOWLEDGE', kor: '지식·노하우', eng: '', emoji: '📚' },
  { code: 'PETS', kor: '반려동물', eng: '', emoji: '🐶' },
  { code: 'NEWS', kor: '뉴스·정치', eng: '', emoji: '📰' },
  { code: 'SPORTS', kor: '스포츠', eng: '', emoji: '⚽' },
  { code: 'AUTOS', kor: '자동차·교통', eng: '', emoji: '🚗' },
  { code: 'ENTERTAINMENT', kor: '엔터테인먼트', eng: '', emoji: '📺' },
  { code: 'TRAVEL', kor: '여행', eng: '', emoji: '✈️' },
  { code: 'FILM', kor: '영화·애니', eng: '', emoji: '🎬' },
  { code: 'MUSIC', kor: '음악', eng: '', emoji: '🎶' },
  { code: 'COMEDY', kor: '코미디', eng: '', emoji: '😂' },
  { code: 'HEALTH', kor: '운동·건강', eng: '', emoji: '🏋️‍♂️' },
  { code: 'FOOD', kor: '음식·요리', eng: '', emoji: '🍲' },
  { code: 'ECONOMICS', kor: '경제·재테크', eng: '', emoji: '💰' },
  { code: 'HUMANITIES', kor: '인문·예술', eng: '', emoji: '🖼' },
  { code: 'IMPROVEMENT', kor: '자기계발', eng: '', emoji: '📖' },
] as ChannelCategory[]

export const ChannelCategoryMap = ChannelCategories.reduce(
  (acc, cur) => {
    acc[cur.code] = cur
    return acc
  },
  {} as Record<string, ChannelCategory>,
)
